import { ComplementGroup } from '@app/types';
import { useEffect } from 'react';

type Props = {
  shouldAutoSelect: boolean;
  groups: ComplementGroup[];
  onCalculated: () => void;
};

export function useAutoSelectRequiredComplements({ groups, shouldAutoSelect, onCalculated }: Props) {
  useEffect(() => {
    if (shouldAutoSelect) {
      const groupsRequired = groups.filter((g) => !g.opcional);
      const groupsWithOneComplement = groupsRequired.filter((g) => g.complementos.length === 1);
      groupsWithOneComplement.forEach((group) => {
        if (group.complementos[0] && group.maximo && group.minimo === group.maximo) {
          group.complementos[0].amount = group.maximo;
        }
      });

      onCalculated();
    }
  }, []);
}
